import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Mail, Shield } from "lucide-react";

const SOCIAL_URL = "https://popl.co/card/SORlV0hl/1/dash";

const TikTokIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.66 20.1a6.34 6.34 0 0 0 10.86-4.43V8.91a8.16 8.16 0 0 0 4.77 1.52V7a4.86 4.86 0 0 1-1.7-.31z" />
  </svg>
);

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative z-10 bg-[#0A0A0A] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 border border-[#D4AF37]/60 flex items-center justify-center">
              <Shield className="w-4 h-4 text-[#D4AF37]" strokeWidth={1.5} />
            </div>
            <div>
              <div className="text-xs tracking-[0.32em] text-[#D4AF37]">IMPACT LEGACY</div>
              <div className="text-xs tracking-[0.32em] text-white/60">GROUP</div>
            </div>
          </div>
          <p className="font-serif text-2xl text-white leading-snug max-w-md">
            Protect Families. Build Leaders. <span className="italic text-[#D4AF37]">Leave a Legacy.</span>
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-5">Navigate</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link data-testid="footer-link-home" to="/" className="hover:text-[#D4AF37] transition-colors">Home</Link></li>
            <li><Link data-testid="footer-link-about" to="/about" className="hover:text-[#D4AF37] transition-colors">About</Link></li>
            <li><Link data-testid="footer-link-insurance" to="/insurance" className="hover:text-[#D4AF37] transition-colors">Insurance Solutions</Link></li>
            <li><Link data-testid="footer-link-careers" to="/careers" className="hover:text-[#D4AF37] transition-colors">Careers</Link></li>
            <li><Link data-testid="footer-link-reviews" to="/reviews" className="hover:text-[#D4AF37] transition-colors">Reviews</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-[#D4AF37] transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="overline mb-5">Connect</div>
          <a
            href="mailto:impactlegacy.davis@gmail.com"
            data-testid="footer-email"
            className="flex items-center gap-3 text-white/80 hover:text-[#D4AF37] transition-colors mb-6"
          >
            <Mail className="w-4 h-4" />
            <span className="text-sm">impactlegacy.davis@gmail.com</span>
          </a>
          <div className="flex items-center gap-4">
            {[
              { Icon: Facebook, label: "Facebook", testid: "social-facebook" },
              { Icon: Instagram, label: "Instagram", testid: "social-instagram" },
              { Icon: TikTokIcon, label: "TikTok", testid: "social-tiktok" },
              { Icon: Linkedin, label: "LinkedIn", testid: "social-linkedin" },
            ].map(({ Icon, label, testid }) => (
              <a
                key={label}
                href={SOCIAL_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={testid}
                aria-label={label}
                className="w-10 h-10 border border-white/10 hover:border-[#D4AF37] hover:text-[#D4AF37] flex items-center justify-center text-white/70 transition-all duration-300"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Impact Legacy Group. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <Link data-testid="footer-privacy" to="/privacy" className="hover:text-[#D4AF37] transition-colors">Privacy Policy</Link>
            <Link data-testid="footer-terms" to="/terms" className="hover:text-[#D4AF37] transition-colors">Terms & Conditions</Link>
            <Link data-testid="footer-admin" to="/admin/login" className="hover:text-[#D4AF37] transition-colors">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
